import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
`;

export const Header = styled.div`
  display: flex;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 12px;
  font-weight: 800;
  color: ${colors.amberDeep};
  background: ${colors.amberSoft};
`;

export const Title = styled.h3`
  font-family: ${font.text};
  font-size: 17px;
  font-weight: 800;
  color: ${colors.ink};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Item = styled.li`
  display: flex;
  gap: 10px;
`;

export const Number = styled.span`
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 12px;
  font-weight: 800;
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
`;

export const Text = styled.p`
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: ${colors.muted};
`;

export const Action = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  border: none;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;

  &:active {
    transform: translateY(2px);
  }
`;
